import React from "react";
import ButtonV2 from "../../../../components/ui/button/v2";
import { cn } from "../../../../lib/utils";
import { ShimmerBlock } from "./ReportDetailsShimmering";

interface IPageHeaderProps {
  isPageLoading: boolean;
  isSaving: boolean;
  disableSave?: boolean;
  disableDiscard?: boolean;
  handleSave: () => void;
  handleDiscard: () => void;
}

const ReportActionHeader: React.FC<IPageHeaderProps> = ({
  isPageLoading,
  isSaving,
  disableSave = false,
  disableDiscard = false,
  handleSave,
  handleDiscard,
}) => {
  const isSaveDisabled = isSaving || disableSave;
  const isDiscardDisabled = isSaving || disableDiscard;

  if (isPageLoading) {
    return (
      <div className="flex gap-3 animate-pulse">
        <ShimmerBlock className="h-8 w-[75.5px]" />
        <ShimmerBlock className="h-8 w-[75.5px]" />
      </div>
    );
  }

  return (
    <div className="flex gap-3">
      <ButtonV2
        variant="outline"
        onClick={handleDiscard}
        disabled={isDiscardDisabled}
        className={cn(
          "font-sans font-medium text-sm leading-5 w-[75.5px] h-8 border-[#3551F3] text-[#3551F3] py-3",
          isDiscardDisabled && "opacity-50 cursor-not-allowed",
        )}
      >
        Discard
      </ButtonV2>
      <ButtonV2
        variant="primary"
        size="sm"
        onClick={handleSave}
        disabled={isSaveDisabled}
        className={cn("font-sans font-medium text-sm", isSaveDisabled && "opacity-50 cursor-not-allowed")}
      >
        {isSaving ? "Saving..." : "Save"}
      </ButtonV2>
    </div>
  );
};

export default ReportActionHeader;
